import { GuardedDeletionService } from 'projects/orchestrator/src/lib/services/guarded-deletion.service';
import { Component, inject } from '@angular/core';
import { ProtectedAreaService } from '../proxy/geographic/controllers';
import { ProtectedAreaProjectionPlanningOrchestratorService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ProtectedAreaCreateDto,
  ProtectedAreaUpdateDto,
} from '../proxy/geographic/dtos/protected-area';
import {
  GetProtectedAreaProjectionListInputDto,
  ProtectedAreaProjectionDto,
  ProtectedAreaProjectionExcelDownloadDto,
} from 'projects/orchestrator/src/lib/proxy/upm/zendra/cms/projection/protected-areas/models';
import { PROTECTEDAREA_CONFIG, PROTECTEDAREA_FIELDS } from './protected-area.config';
import {
  BaseHierarchicalCrudComponent,
  GenericForm,
  IActionsSchema,
  ICrudService,
  ZnHierarchicalViewComponent,
} from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-protected-area',
  imports: [CommonModule, GenericForm, ZnHierarchicalViewComponent],
  providers: [ListService, ProtectedAreaService, ConfirmationService],
  templateUrl: './protected-area.html',
  styleUrl: './protected-area.scss',
})
export class ProtectedArea extends BaseHierarchicalCrudComponent<
  ProtectedAreaProjectionDto,
  ProtectedAreaCreateDto,
  ProtectedAreaUpdateDto,
  ProtectedAreaProjectionExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  private readonly geographicService = inject(ProtectedAreaService);
  private readonly orchestratorService = inject(
    ProtectedAreaProjectionPlanningOrchestratorService,
  );

  service: ICrudService<
    ProtectedAreaProjectionDto,
    ProtectedAreaCreateDto,
    ProtectedAreaUpdateDto,
    ProtectedAreaProjectionExcelDownloadDto
  > = {
    create: input => this.geographicService.create(input),
    update: (id, input) => this.geographicService.update(id, input),
    deleteByIds: ids => this.guardedDeletion.deleteByIds('protected-areas', ids),
    projectionConsistency: this.createProjectionConsistency(
      this.orchestratorService,
      'protectedAreaId',
    ),
    getList: (query: GetProtectedAreaProjectionListInputDto) =>
      this.orchestratorService.getList(query),
    getDownloadToken: () => this.orchestratorService.getDownloadToken(),
    getListAsExcelFile: input => this.orchestratorService.getListAsExcelFile(input),
  };
  config = PROTECTEDAREA_CONFIG;
  fields = PROTECTEDAREA_FIELDS;
  actions: IActionsSchema | null = null;

  protected prepareUpdateDto(
    data: any,
    selected: ProtectedAreaProjectionDto,
  ): ProtectedAreaUpdateDto {
    return {
      name: data.name,
      area: data.area,
      recordNumber: data.recordNumber,
      officialArea: data.officialArea,
      isDinamaProtected: data.isDinamaProtected,
      propertyLocationId: data.propertyLocationId,
      conservationTypeId: data.conservationTypeId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ProtectedArea';
  }
}
